import { render, staticRenderFns } from "./Uygunsuzluklar.vue?vue&type=template&id=7af0c317"
import script from "./Uygunsuzluklar.vue?vue&type=script&lang=js"
export * from "./Uygunsuzluklar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports